import React from 'react'

import { Badge } from 'slab'

export const InghestionJobStatusBadge: React.FC<{ status: string; }> = ({ status }) => {
  let type: React.ComponentProps<typeof Badge>['type'] = 'neutral'
  let displayStatus = status.charAt(0).toUpperCase() + status.slice(1)

  switch (status) {
    case 'queued':
      type = 'slate'

      break
    case 'running':
      type = 'caution'

      break
    case 'succeeded':
      type = 'success'

      break
    case 'failed':
      type = 'critical'

      break
    case 'cancelled':
      type = 'warning'

      break
    case 'partial_success':
      type = 'warning'
      displayStatus = 'Partial Success'
      break
  }

  return (
    <div className='flex items-center gap-1'>
      <Badge type={type}>{displayStatus}</Badge>
    </div>
  )
}
